import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { TaskDirective } from './directive/task.directive';

import { CardComponent } from './components/card/card.component';
import { AutocompletedComponent } from './components/autocompleted/autocompleted.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ErrorComponent } from './components/error/error.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { TableComponent } from './components/table/table.component';

// Primeng
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ChipsModule } from 'primeng/chips';
import { PanelModule } from 'primeng/panel';

import { InputTextareaModule } from 'primeng/inputtextarea';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { StepsModule } from 'primeng/steps';
import { InputMaskModule } from 'primeng/inputmask';

import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';

import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { EditBtnComponent } from './components/buttons/editar-btn.component';
import { FilterBtnComponent } from './components/buttons/filtro-btn.component';
import { TextAreaComponent } from './components/text-area/text-area.component';
import { ChipsComponent } from './components/chips/chips.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { InputMaskComponent } from './components/input-mask/input-mask.component';
import { CancelarBtnComponent } from './components/buttons/cancelar-btn.component';
import { FinalizarBtnComponent } from './components/buttons/finalizar-btn.component';
import { GuardarBtnComponent } from './components/buttons/guardar-btn.component';
import { LimpiarBtnComponent } from './components/buttons/limpiar-btn.component';
import { PagarBtnComponent } from './components/buttons/pagar-btn.component';
import { BuscarBtnComponent } from './components/buttons/buscar-btn.component';
import { AgregarCarritoBtnComponent } from './components/buttons/agregar-carrito-btn.component';
import { ConfirmarBtnComponent } from './components/buttons/confirmar-btn.component';



// Pipe
import { CheckEmptyPipe } from './pipes/check-empty.pipe';
import { SafePipe } from './pipes/safe.pipe';

// Custom
import { HelpIconComponent } from './components/help-icon/help-icon.component';
import { HelpModalComponent } from './components/help-modal/help-modal.component';
import { TableSelPapeleriaComponent } from './components/table-sel-papeleria/table-sel-papeleria.component';
import { AtrasBtnComponent } from './components/buttons/atras-btn.component';


@NgModule({
    declarations: [
        TaskDirective,
        CardComponent,

        ErrorComponent,
        InputTextComponent,
        AutocompletedComponent,
        DropdownComponent,
        CalendarComponent,
        TableComponent,
        MultiselectComponent,

        FilterBtnComponent,
        EditBtnComponent,
        LimpiarBtnComponent,
        AtrasBtnComponent,
        PagarBtnComponent,
        TextAreaComponent,
        ChipsComponent,
        InputNumberComponent,
        InputMaskComponent,
        CheckEmptyPipe,
        SafePipe,
        BuscarBtnComponent,
        CancelarBtnComponent,
        FinalizarBtnComponent,
        GuardarBtnComponent,
        HelpIconComponent,
        HelpModalComponent,
        AgregarCarritoBtnComponent,
        TableSelPapeleriaComponent,
        ConfirmarBtnComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,


        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),

        RippleModule,
        ButtonModule,
        CheckboxModule,
        InputSwitchModule,
        InputNumberModule,
        MultiSelectModule,
        InputTextareaModule,
        InputTextModule,
        DropdownModule,
        DialogModule,
        ConfirmDialogModule,
        ScrollPanelModule,
        PanelModule,
        ToastModule,
        ProgressSpinnerModule,
        CardModule,
        TabViewModule,
        AutoCompleteModule,
        CalendarModule,
        TableModule,
        ChipsModule,
        StepsModule,
        InputMaskModule,
        MessageModule,
        MessagesModule,
    ],
    exports: [
        // Commons Modules
        HttpClientModule,
        ReactiveFormsModule,
        TranslateModule,

        TaskDirective,

        // Primeng Modules
        RippleModule,
        ButtonModule,
        CheckboxModule,
        InputSwitchModule,
        InputNumberModule,

        MultiSelectModule,
        ScrollPanelModule,
        PanelModule,
        ConfirmDialogModule,
        ProgressSpinnerModule,
        ToastModule,
        DialogModule,
        DynamicDialogModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        TabViewModule,
        ChipsModule,
        StepsModule,
        CardModule,
        InputMaskModule,
        MessageModule,
        MessagesModule,

        // Components
        CardComponent,
        ErrorComponent,
        InputTextComponent,
        TextAreaComponent,
        AutocompletedComponent,
        MultiselectComponent,
        DropdownComponent,
        CalendarComponent,
        TableComponent,
        ChipsComponent,
        InputMaskComponent,

        FilterBtnComponent,
        EditBtnComponent,
        LimpiarBtnComponent,
        AtrasBtnComponent,
        PagarBtnComponent,
        BuscarBtnComponent,
        CancelarBtnComponent,
        FinalizarBtnComponent,
        GuardarBtnComponent,
        InputNumberComponent,
        HelpIconComponent,
        HelpModalComponent,
        AgregarCarritoBtnComponent,
        TableSelPapeleriaComponent,
        ConfirmarBtnComponent,

        // Pipe
        CheckEmptyPipe
    ]
})
export class SharedModule { }
